<div class="input-container">
  <input
    type="text"
    class="picker-input"
    [formControl]="myFormControl"
    [placeholder]="question?.placeholder || dateFormat"
    (blur)="setDate()"
    [attr.disabled]="disabled"
    [attr.tabindex]="tabIndex"
  />

  <input
    type="text"
    id="{{ 'question-input-' + question.id }}"
    class="picker-el"
    [ngClass]="{ hidden: disabled || myFormControl.disabled }"
    #datePicker
    [attr.tabindex]="tabIndex"
  />

  <i class="calendar alternate outline icon"></i>

  @if (myFormControl?.errors) {
  <div class="clear validation-text">
    @if (myFormControl?.errors?.required) {
    <div>{{ question?.question }} {{ "is-required" | transloco }}</div>
    } @if ( myFormControl?.value && myFormControl?.value.length === 10 &&
    myFormControl?.errors?.minDate ) {
    <div>
      {{ question?.question }} {{ "cannot-be-less-than" | transloco }}
      {{ question?.minDate }}
    </div>
    } @if ( myFormControl?.value && myFormControl?.value.length === 10 &&
    myFormControl?.errors?.maxDate ) {
    <div>
      {{ question?.question }} {{ "cannot-be-more-than" | transloco }}
      {{ question?.maxDate }}
    </div>
    } @if ( myFormControl?.value && myFormControl?.value.length >= 10 &&
    myFormControl?.errors?.pattern ) {
    <div>
      {{ "please-enter-a-valid-date" | transloco }}
    </div>
    }
  </div>
  }
</div>
